import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

/**
 * Footer-Komponente der Website
 * Zeigt Kontaktdaten, rechtliche Links und Informationen über den Betreiber
 * Verwendet ein dunkles Design mit den Markenfarben
 */
export default function Footer() {
  // Aktuelles Jahr für das Copyright
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Hauptbereich mit drei Spalten */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Kontakt-Informationen */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#A8D08D]">Kontakt</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#A8D08D]" />
                <span className="text-sm">Lauchagrundstraße 72<br />99891 Bad Tabarz</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#A8D08D]" />
                <span className="text-sm">+49 36259 5600</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#A8D08D]" />
                <span className="text-sm">info@bad-tabarz.de</span>
              </div>
            </div>
          </div>

          {/* Rechtliche Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#A8D08D]">Rechtliches</h3>
            <ul className="space-y-2">
              <li><a href="/impressum" className="text-sm hover:text-[#A8D08D] transition-colors">Impressum</a></li>
              <li><a href="/datenschutz" className="text-sm hover:text-[#A8D08D] transition-colors">Datenschutz</a></li>
              <li><a href="/barrierefreiheitserklaerung" className="text-sm hover:text-[#A8D08D] transition-colors">Barrierefreiheitserklärung (Webseite)</a></li>
              <li><a href="/gebuehrenordnung" className="text-sm hover:text-[#A8D08D] transition-colors">Gebührenordnung</a></li>
              <li><a href="/hausordnung" className="text-sm hover:text-[#A8D08D] transition-colors">Hausordnung</a></li>
            </ul>
          </div>

          {/* Informationen über den Betreiber */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#A8D08D]">KUR Bad Tabarz</h3>
            <div className="space-y-3">
              <p className="text-sm text-gray-300">
                Der Veranstaltungsraum Arenarisquelle wird von der Kur- und Reiseverkehr Bad Tabarz kAöR betrieben und vermietet.
              </p>
              <div className="flex flex-col gap-2">
                <a 
                  href="https://www.tabbs.de" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block bg-[#0D5C63] hover:bg-[#0A4A50] text-white px-4 py-2 rounded-lg text-sm transition-colors"
                >
                  Zur TABBS-Website
                </a>
                <a 
                  href="https://www.bad-tabarz.de"
                  rel="noopener noreferrer"
                  className="inline-block bg-[#0D5C63] hover:bg-[#0A4A50] text-white px-4 py-2 rounded-lg text-sm transition-colors"
                >
                  Zur Gemeinde Bad Tabarz
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Untere Zeile mit Copyright und Credits */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400">
              © {currentYear} Kur- & Reiseverkehr Bad Tabarz - Veranstaltungsraum <a href="/" target="_blank" rel="noopener noreferrer" className="text-[#A8D08D] hover:text-white hover:underline focus:outline-none focus:ring-2 focus:ring-[#A8D08D] focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-200 font-medium">Arenarisquelle</a>. Alle Rechte vorbehalten.
            </div>
            <div className="flex items-center gap-4 mt-4 md:mt-0">
              <span className="text-xs text-gray-300">
                Design & Development by <a 
                  href="https://salzer-siegel.de" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-[#A8D08D] hover:text-white hover:underline focus:outline-none focus:ring-2 focus:ring-[#A8D08D] focus:ring-offset-2 focus:ring-offset-gray-900 transition-all duration-200 font-medium"
                  aria-label="Salzer & Siegel - Externe Website öffnet in neuem Tab"
                >
                  Salzer & Siegel
                  <span className="sr-only"> (öffnet in neuem Tab)</span>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
